import { Theme } from '@mui/material';

export const intakeFormStyles = (theme: Theme) => ({
	root: {
		display: 'flex',
		flexDirection: 'column',
		gap: '24px',
	},
	categoryBox: {
		display: 'flex',
		flexDirection: 'column',
		gap: '24px',
	},
	categoryTitle: {
		fontFamily: 'Integral CF',
		fontSize: '17px',
		fontWeight: 500,
		lineHeight: '20px',
		color: '#FFFFFF',
	},
	inputsBox: {
		display: 'flex',
		flexFlow: 'column nowrap',
		gap: { xs: '16px', md: '24px' },
	},
	radioGroup: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		gap: '16px',
	},
	radioGroupOption: {
		color: '#FFFFFF',
		ml: 0,
		gap: '12px',
		minWidth: '120px',

		'& .MuiFormControlLabel-label': {
			fontFamily: 'Montserrat',
			fontSize: '15px',
			fontWeight: 500,
			lineHeight: '21px',

			'&.Mui-disabled': {
				color: 'rgba(255, 255, 255, 0.6)',
			},
		},

		'& .MuiRadio-root': {
			height: '18px',
			width: '18px',
			p: 0,
			backgroundColor: '#FFFFFF33',
			boxShadow: '0 0 0 1px #FFFFFF4D',


			'&:hover': {
				backgroundColor: '#FFFFFF33',
				boxShadow: '0 0 0 1px #FFFFFF',
			},

			"& .MuiSvgIcon-root": {
				display: 'none',
			},

			'&.Mui-checked': {
				color: '#FFFFFF',
				boxShadow: '0 0 1px #FFFFFF4D',

				"&::after": {
					content: '""',
					position: 'absolute',
					top: '4px',
					left: '4px',
					width: '10px',
					height: '10px',
					borderRadius: '50%',
					backgroundColor: '#FFFFFF',
				},
			}
		}
	},
	checkBox: {
		color: '#FFFFFF',
		m: 0,
		gap: '12px',
		minWidth: '120px',

		'& .MuiStack-root': {
			flex: 1,
		},

		'& .MuiFormControlLabel-label': {
			fontFamily: 'Montserrat',
			fontSize: '15px',
			fontWeight: 500,
			lineHeight: '21px',
			userSelect: 'none',

			'&.Mui-disabled': {
				color: 'rgba(255, 255, 255, 0.6)',
			},
		},

		'& .MuiFormControlLabel-asterisk': {
			fontFamily: 'Montserrat',
			fontSize: '15px',
			fontWeight: 500,
			lineHeight: '21px',
			color: '#FF0606',
			ml: '4px'
		},

		'& .MuiCheckbox-root': {
			height: '18px',
			width: '18px',
			p: 0,
			borderRadius: '4px',
			boxShadow: '0 0 0 1px #FFFFFF4D',
			backgroundColor: '#FFFFFF33',

			'&:hover': {
				backgroundColor: '#FFFFFF33',
				boxShadow: '0 0 0 1px #FFFFFF',
			},

			'& .MuiSvgIcon-root, & .MuiTouchRipple-root': {
				display: 'none',
			},

			'&.Mui-checked': {
				color: '#FFFFFF',
				boxShadow: '0 0 0 1px #FFFFFF4D',

				'& .MuiSvgIcon-root': {
					width: '14px',
					height: '14px',
					display: 'block',
				},
			}
		},
	},
	checkBoxError: {
		'& .MuiCheckbox-root': {
			boxShadow: '0 0 0 1px #FF563F',

			'&:hover': {
				boxShadow: '0 0 0 1px #FF563F',
			},

			'&.Mui-checked': {
				boxShadow: '0 0 0 1px #FF563F',
			}
		}
	},
	radioOptionError: {
		'& .MuiRadio-root': {
			boxShadow: '0 0 0 1px #FF563F',

			'&:hover': {
				boxShadow: '0 0 0 1px #FF563F',
			},

			'&.Mui-checked': {
				boxShadow: '0 0 0 1px #FF563F',
			}
		}
	},
	datePicker: {
		'& .MuiInputBase-root': {
			backgroundColor: '#FFFFFF0D',
			color: '#FFFFFF',
			borderRadius: '12px',

			'& .MuiInputBase-input': {
				height: 'auto',
				p: '13px 16px',
				fontFamily: 'Montserrat',
				fontSize: '16px',
				fontWeight: 500,
				lineHeight: '20px',

				'&::placeholder': {
					color: '#FFFFFF',
					opacity: 0.3,
				},

				'&.Mui-disabled': {
					WebkitTextFillColor: 'unset',
					color: 'rgba(255, 255, 255, 0.6)'
				},
			},

			'& .MuiInputAdornment-root .MuiSvgIcon-root': {
				color: '#FFFFFF99',
			},

			'&.MuiOutlinedInput-root': {
				'&:hover .MuiOutlinedInput-notchedOutline': {
					borderWidth: '1px',
					borderColor: '#FFFFFF0D',
				},

				'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
					borderWidth: '1px',
					borderColor: '#FFFFFF99',
				},

				'&.Mui-error .MuiOutlinedInput-notchedOutline': {
					borderWidth: '1px',
					borderColor: '#FF563F',
				}
			},
		},

		'& .MuiOutlinedInput-notchedOutline': {
			borderWidth: 0,
			borderRadius: '12px',
		},
	},
	waiverUrl: {
		fontFamily: 'Montserrat',
		fontSize: '15px',
		fontWeight: 400,
		color: '#FFFFFFB2',
		wordBreak: 'break-word',

		'& >a': {
			color: '#FFFFFF',
			outline: 0,
		}
	},
});
